import Vue from 'vue';
import config from '../config/index.js';

export default {
  login(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/login`, params);
  },
  getUserInfo() {
    return Vue.axios.get(`${config.base_url}/roses-platform/getLoginUser`);
  },
  logout() {
    return Vue.axios.get(`${config.base_url}/roses-platform/logout`);
  },
  // 获取app地址
  getAppAddress(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/rest/appVersion/getAddress`, {
      params
    });
  },
  // 获取app列表
  getAppList() {
    return Vue.axios.get(`${config.base_url}/roses-platform/appVersion/systermList`);
  },
  // 获取安卓地址
  getAndroidAddress(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/rest/appVersion/getAndroidAddress`, {
      params
    });
  },
  // 获取ios地址
  getIOSAddress(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/rest/appVersion/getIOSAddress`, {
      params
    });
  },
  // 获取验证码(data:image/jpg;base64,)
  getVerifyCode(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/verifyCode`);
  },
  // 是否是第一次登陆
  firstlogin(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/firstlogin`, { params });
  },
  // 短信验证码
  sendSmsCode(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sendSmsCode`, { params });
  },
  // 是否需要修改密码
  needChangePwd(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/needChangePwd`);
  },
  // 修改密码
  updatePwd(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/updatePwd`, params);
  }
};
